import { Theme, css } from '@emotion/react';

export const formToggleButtonGroupFieldStyles = ({ spacing }: Theme) => css`
  margin: 0 ${spacing(0.25)}px;
`;

export const formToggleButtonGroupFieldLabelStyles = ({ colors }: Theme) => css`
  color: ${colors.fgDefault};
`;

export const formToggleButtonGroupFieldHelperTextStyles = ({ spacing }: Theme) => css`
  margin-top: ${spacing(1)}px;
`;

export const formToggleButtonGroupFieldDisabledStyles = css`
  pointer-events: none;
`;
